import { render, staticRenderFns } from "./EmployeeTrainingDetailCourses.vue?vue&type=template&id=2a50e306&"
import script from "./EmployeeTrainingDetailCourses.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTrainingDetailCourses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports